import { EmailAnalysisEmail } from "@types";

export enum MessageWizardTargetType {
  Question = "question",
  FinishAction = "finishAction",
  CancelAction = "cancelAction",
}

export enum MessageWizardQuestionType {
  Immediate = "immediate",
  Global = "global",
}

export enum MessageWizardFooterMessageType {
  Copy,
  PositiveFeedback,
  NegativeFeedback,
}

export interface MessageWizardResult {
  questionId: string;
  answerId: string;
}

export interface MessageWizardAnswerTarget {
  type: MessageWizardTargetType;
  targetId: string | null;
}

export interface MessageWizardAnswer {
  optionId: string;
  text: string;
  target: MessageWizardAnswerTarget;
}

export interface MessageWizardQuestion {
  index: number;
  options: MessageWizardAnswer[];
  overrides: string | null;
  qType: MessageWizardQuestionType;
  showInHistory: boolean;
  text: string;
  tooltip: string | null;
  wqId: string;
}

export interface MessageWizardRephraseResult {
  isSuccessful: boolean;
  newText: string;
  sentiment: EmailAnalysisEmail["sentiment"];
  participants: EmailAnalysisEmail["participants"];
  dominantParticipant: EmailAnalysisEmail["dominantParticipant"];
  scoreInBranch: EmailAnalysisEmail["scoreInBranch"];
}

export interface MessageWizardState {
  isLoading: {
    questionnaire: boolean;
    rephrase: boolean;
    savedResults: boolean;
    feedback: boolean;
  };
  isError: {
    questionnaire: boolean;
    rephrase: boolean;
    savedResults: boolean;
    feedback: boolean;
  };
  isCompleted: boolean;
  isTextCopied: boolean;
  isPositiveFeedback: boolean | null;
  questions: MessageWizardQuestion[];
  savedResults: MessageWizardResult[];
  rephraseResult: MessageWizardRephraseResult | null;
}
